import {CALL_API} from 'middleware/api';

export const JOIN = 'JOIN';
export const SUCCESS_JOIN = 'SUCCESS_JOIN';
export const FAILURE_JOIN = 'FAILURE_JOIN';

export const CHANGE_JOIN_TYPE = 'CHANGE_JOIN_TYPE';

function fetchJoin(data) {
    return {
        type: JOIN,
        [CALL_API]: {
            endpoint: '/api/join/',
            method: 'post',
            types: [SUCCESS_JOIN, FAILURE_JOIN],
            credentials: true,
            data
        }
    };
}

export function join(data) {
    return (dispatch) => {
        dispatch(fetchJoin(data));
    };
}

export function changeJoinType(data) {
    return (dispatch) => {
        dispatch({
            type: CHANGE_JOIN_TYPE, data
        })
    };
}



// WEBPACK FOOTER //
// ./js/actions/auth/Join.js